import _ from 'lodash';
import React from 'react';
import { getPlacesAutocomplete } from '../../../../api';

export type AutocompleteSuggestionType = {
  active: boolean;
  placeId: string;
  formattedSuggestion: { mainText: string; secondaryText: string };
};

export const fetchSuggestions = async (
  placeInput: string,
  isFilledAddressValid: boolean,
  setSuggestions: React.Dispatch<React.SetStateAction<any[]>>,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  handleAddressInputFormControlError: (
    status: any,
    clearSuggestions: () => void
  ) => void
) => {
  if (placeInput.length < 5 || isFilledAddressValid) {
    setSuggestions([]);
    return;
  }
  try {
    setIsLoading(true);
    const resultData = await getPlacesAutocomplete(placeInput);
    setSuggestions(() =>
      _.map(resultData?.suggestions, (suggestion, index) => ({
        active: parseInt(index) === 0,
        placeId: suggestion.placePrediction?.placeId,
        formattedSuggestion: {
          mainText:
            suggestion.placePrediction?.structuredFormat?.mainText?.text,
          secondaryText:
            suggestion.placePrediction?.structuredFormat?.secondaryText?.text,
        },
      }))
    );
  } catch (error) {
    handleAddressInputFormControlError(error, ()=>setSuggestions([]));
  }

  setIsLoading(false);
};

export const handleTypedAdress = (
  adressInput: string,
  setTypedAddress: React.Dispatch<React.SetStateAction<string>>,
  setSuggestions: React.Dispatch<React.SetStateAction<any[]>>
) => {
  setTypedAddress(adressInput);
  if (adressInput.length < 5) {
    setSuggestions([]);
  }
};

export const handleSelectSuggestion = (
  suggestion: AutocompleteSuggestionType,
  handleAddressSelection: (
    selectedAddressValue: any,
    placeId: string
  ) => Promise<void>
) => {
  handleAddressSelection(
    `${suggestion.formattedSuggestion.mainText}, ${suggestion.formattedSuggestion.secondaryText}`,
    suggestion.placeId
  );
};
